<template>
  <div>
    <vxe-modal
      v-model="dialogVisible"
      :before-hide-method="handleClose"
      width="80%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>受伤类型</span>
      </template>
      <template #default>
        <div class="single-content-wrapper">
          <el-row class="btn-row">
            <!-- 按钮节点区域-->
            <div class="option">
              <el-button
                @click="handleConfirm"
                v-if="Opt !='view'"
              >
                <span>提交</span>
              </el-button>
              <el-button @click="handleCancel">
                <span>关闭</span>
              </el-button>
            </div>
          </el-row>
          <!-- 表达区域-->
          <div class="switch-display border-all">
            <!-- 表单区域-->
            <div class="switch-content">
              <el-form
                ref="PartInfoRef"
                :model="PartInfo"
                :rules="PartInfoRules"
                size="small"
                class="singleContent"
                :disabled="Opt == 'view'"
              >
                <el-row
                  :gutter="20"
                  class="row-bg"
                >
                  <el-col :span="8">
                    <div class="grid-content bg-purple">
                      <el-form-item
                        label="代码:"
                        prop="code"
                      >
                        <el-input
                          id="code"
                          v-model="PartInfo.code"
                          clearable
                          :disabled="Opt != 'insert'"
                        />
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple">
                      <el-form-item
                        label="名称:"
                        prop="name"
                      >
                        <el-input
                          id="name"
                          v-model="PartInfo.name"
                          clearable
                        />
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple">
                      <el-form-item label="大类:" prop="parentId">
                        <LoadMoreSelector
                          v-model="PartInfo.parentId"
                          placeholder="大类"
                          url="/api/app/injuryPart/list"
                          :filterable="true"
                          :multiple="false"
                          :remote="true"
                          :formater="formater"
                          :queryModel="{level:1}"
                          :ids="PartInfo.parentId"
                        />
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row
                  :gutter="20"
                  class="row-bg"
                >
                  <el-col :span="24">
                    <div class="grid-content bg-purple">
                      <el-form-item
                        label="简述:"
                        prop="remark"
                      >
                        <el-input
                          id="describe"
                          type="textarea"
                          v-model="PartInfo.remark"
                          clearable
                        />
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import { AddinjuryPart, ModifyinjuryPart } from "@api/ApiInjuryPart";
import { toRefs, ref, unref, reactive, onUpdated } from "vue";
import { ElMessage } from "element-plus";
// 自定义分页下拉组件
import LoadMoreSelector from "@comp/SelectorWithLoadMore/index";

export default {
  name: "InjuryPartEdit",
  components: {
    LoadMoreSelector
  },
  setup(props, content) {
    const PartInfoRef = ref();
    const OriginalData = () => {
      return {
        dialogVisible: false,
        Opt: "",
        PartInfoRules: {
          code: [
            {
              required: true,
              message: "请输入代码",
              trigger: "blur",
            },
            {
              min: 3,
              max: 5,
              message: "长度在3到5之间",
              trigger: "blur",
            },
          ],
          name: [
            {
              required: true,
              message: "名称",
              trigger: "blur",
            },
          ],
          remark: [
            {
              required: true,
              message: "简述",
              trigger: "blur",
            },
          ],
        },
        PartInfo: {
          code: "",
          name: "",
          remark: "",
        },
      };
    };
    let data = reactive(OriginalData());
    //关闭
    const handleClose = () => {
      data.dialogVisible = false;
      Object.assign(data, OriginalData());
      content.emit("close-dialog");
    };
    //关闭
    const handleCancel = () => {
      handleClose();
    };
    //提交
    const handleConfirm = async () => {
      const form = unref(PartInfoRef);
      if (!form) return;
      try {
        form.validate((valid) => {
          if (valid) {
            if (data.Opt == "insert") {
              AddinjuryPart(data.PartInfo)
                .then(function (result) {
                  ElMessage.success("新增成功！");
                  data.Opt = "view";
                })
                .catch(({ message }) => {
                  ElMessage.error("新增失败!" + message);
                });
            } else {
              if(data.PartInfo.parentId) {
                data.PartInfo.level = 2;
              }
              ModifyinjuryPart(data.PartInfo)
                .then(function (result) {
                  ElMessage.success("修改成功！");
                  data.Opt = "view";
                })
                .catch((error) => {
                  ElMessage.error("修改失败!" + error);
                });
            }
          }
        });
      } catch (error) {}
    };
    //初始化页面
    const initDialog = (Opt, row) => {
      data.dialogVisible = true;
      data.Opt = Opt;
      if (row) {
        data.PartInfo = row;
        if(data.PartInfo.parentId == 0) {
          delete data.PartInfo.parentId
        }
      }
    };
    // 下拉框格式化数据
    const formater = (data) => {
      return (
        data &&
        data.map((itm) => ({
          ...itm,
          key: itm.id,
          value: itm.id,
          label: itm.name,
        }))
      );
    }
    onUpdated(() => {
      //清除校验
      const form = unref(PartInfoRef);
      if (!form) return;
      form.clearValidate();
    });

    return {
      ...toRefs(data),
      PartInfoRef,
      handleClose,
      handleCancel,
      handleConfirm,
      initDialog,
      formater
    };
  },
};
</script>

<style lang="scss" scoped>
.formtable {
  padding: 0 20px;
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 5px 0;
}

.Commit {
  padding: 20px 0;
  text-align: center;
}
::v-deep .el-form-item__label {
  width: 80px;
  padding: 0;
  text-align: left;
}
.tyyzm ::v-deep .el-form-item__label {
  width: 120px;
}
.textarea-note {
  font-size: var(--el-form-label-font-size);
  padding: 5px 0;
}
.el-textarea {
  margin: 5px 0;
  width: 100%;
}
.btn-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 5px;
}

.option {
  margin: 0px 0 20px 20px;
  .el-button {
    min-height: 0;
    background: #1c6de4;
    border-radius: 3px;
    font-size: 12px;
    color: #ffffff;
    padding: 12px 20px;
    border: 0;

    .custom-icon {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }
}
.single-content-wrapper {
  min-height: 60vh;
  background-color: #fff;
  padding-bottom: 15px;
}
.switch-display {
  position: relative;
}
.border-all {
  border: 1px solid #dcdfe6;
}
</style>
